export default __webpack_public_path__ + "static/media/btn_plus_blue.6c021516.svg";